import { Box } from '@mui/material';

import { useCalibrationMatrixAppraisalWindows } from '@/queries/useCalibrationMatrix';
import type { Rating } from '@/api/types/calibrationMatrix.types';

import { StatusChip } from './StatusChip';

interface PromotionWindowChipProps {
  appraisalId: number;
  proposedRating: Rating | null;
  isCurrentUserAppraisee: boolean;
}

export function PromotionWindowChip({
  appraisalId,
  proposedRating,
  isCurrentUserAppraisee,
}: PromotionWindowChipProps) {
  const { data, isError } = useCalibrationMatrixAppraisalWindows(
    !isCurrentUserAppraisee ? appraisalId : null
  );

  if (isCurrentUserAppraisee) return null;
  if (proposedRating == null) return null;
  if (isError || !data) return null;

  const flag =
    proposedRating === 'BT'
      ? data.inPromotionWindow.bt
      : proposedRating === 'OT'
        ? data.inPromotionWindow.ot
        : proposedRating === 'AT'
          ? data.inPromotionWindow.at
          : data.inPromotionWindow.o;

  if (!flag) return null;

  return (
    <Box aria-live="polite" data-testid="promotion-window-chip">
      <StatusChip status="promotionWindow" />
    </Box>
  );
}

export default PromotionWindowChip;
